<template>
  <div id="app">
    <div class="controls l-inline l-gap-2">
      <div class="" v-for="viewSetting in settings.views" v-if="!viewSetting.hidden">
        <label>
          <input type="checkbox" v-model="viewSetting.value" />
          <span>{{viewSetting.label}}</span>
        </label>
      </div>
      <button type="button" name="button" v-on:click="reload">Reset</button>
      <button type="button" name="button" v-on:click="saveToFiles">Save</button>
    </div>
    <div class="l-inline">
      <div class="view__editor l-stack" v-if="settings.views.markdown.value">
        <textarea v-model="markdown" class="input" name="" id="" cols="30" rows="10"></textarea>
      </div>
      <div class="view__preview" v-if="settings.views.preview.value">
        <Preview :input="markdown" :onSelect="handleElementSelection" :onChange="handleContentChange" />
      </div>
      <div class="view__css" v-if="settings.views.css.value" style="max-width: 500px">
        <StyleEditor :code="css" v-if="css" :search="search" :onChange="handleStyleChange" />
      </div>
    </div>
  </div>
</template>

<script>
var beautify_css = require("js-beautify").css;
var beautifyOptions = {
  indent_size: 2,
  indent_char: " ",
  indent_with_tabs: false,
  eol: "\n",
  end_with_newline: false,
  indent_level: 0,
  preserve_newlines: true,
  max_preserve_newlines: 10,
  space_in_paren: false,
  space_in_empty_paren: false,
  jslint_happy: false,
  space_after_anon_function: false,
  brace_style: "collapse",
  unindent_chained_methods: false,
  break_chained_methods: false,
  keep_array_indentation: false,
  unescape_strings: false,
  wrap_line_length: 0,
  e4x: false,
  comma_first: false,
  operator_position: "before-newline"
};

import Preview from "./components/Preview";
import StyleEditor from "./components/StyleEditor";

export default {
  name: "app",
  components: {
    Preview,
    StyleEditor
  },
  data: function() {
    return {
      css: "",
      markdown: "",
      search: "",
      settings: {
        views: {
          css: {
            label: "CSS",
            value: false
          },
          markdown: {
            label: "Markdown",
            value: false
          },
          preview: {
            label: "Preview",
            value: true,
            hidden: true
          }
        },
        loadFromLocalStorage: false
      }
    };
  },
  methods: {
    applyStyles: function(code) {
      if (document.getElementById("injectedStyle") != null) {
        var styleElement = document.getElementById("injectedStyle");
        styleElement.innerHTML = code;
      } else {
        var styleElement = document.createElement("style");

        styleElement.setAttribute("type", "text/css");
        styleElement.setAttribute("id", "injectedStyle");
        styleElement.innerHTML = code;

        document.head.appendChild(styleElement);
      }
    },
    handleContentChange: function(content) {
      this.markdown = content;

      if (
        this.markdown != "" &&
        this.markdown != "null" &&
        this.markdown != null
      ) {
        localStorage.setItem("content", this.input);
      }
    },
    handleElementSelection: function(tagName) {
      this.search = tagName;
      this.settings.views.css.value = true;
      // this.settings.views.markdown.value = true
    },
    handleStyleChange: function(css) {
      // set
      this.css = css;

      // save
      localStorage.setItem("css", this.css);

      // apply
      this.applyStyles(css);
    },
    reload: function() {
      localStorage.setItem("content", null);
      localStorage.setItem("css", null);
      location.reload();
    },
    saveToFiles: function() {
      var url;

      if (window.location.href.indexOf("localhost") != -1) {
        url = "http://localhost/~fs/portfolio-os/static/io/save.php";
      } else {
        url = "static/io/save.php";
      }

      var data = {
        css: this.css,
        markdown: this.markdown,
        html: document.querySelector(".content").innerHTML,
        key: prompt("Password")
      };

      // Save styles and content by posting it to the PHP endpoint
      fetch(url, {
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json"
        },
        method: "post",
        body: JSON.stringify({
          payload: data
        })
      }).then(response => {
        response.text().then(result => {
          console.log(result);
        });
      });
    }
  },
  mounted: function() {
    var that = this;

    // remove default styles
    document
      .querySelector('link[rel=stylesheet][href~="static/styles.css"]')
      .remove();

    if (
      this.settings.loadFromLocalStorage &&
      localStorage.getItem("content") != "null" &&
      localStorage.getItem("content") != null
    ) {
      this.markdown = localStorage.getItem("content");
    } else {
      fetch("static/content.md").then(response => {
        response.text().then(data => {
          that.markdown = data;
        });
      });
    }

    if (
      this.settings.loadFromLocalStorage &&
      localStorage.getItem("css") != "null" &&
      localStorage.getItem("css") != null
    ) {
      this.css = beautify_css(
        "" + localStorage.getItem("css"),
        beautifyOptions
      );
      this.applyStyles(this.css);
    } else {
      fetch("static/styles.css").then(response => {
        response.text().then(css => {
          that.handleStyleChange(css);
        });
      });
    }
  }
};
</script>

<style lang="scss">
@import "styles/utils";

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.view__preview {
  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    cursor: default;
  }
}

body {
  min-height: 100vh;
  width: 100%;
}

.view__css {
  // width: 480px;
  height: 100vh;
  border-left: 1px solid rgba(0, 0, 0, 0.08);
}

.view__preview {
  width: 100%;
  max-width: 100%;
}

.view__editor {
  background: #fafafa;
  min-height: 100vh;
  align-items: center;
  padding: 4rem;
  border-right: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: inset -1px 0 2px rgba(0, 0, 0, 0.03);
}

.input {
  width: 700px;
  height: 100%;
  font-size: 18px;
  font-family: "Fira Mono", monospace;
  outline: 0;
  border: 0;
  padding: 2rem;
  background: transparent;
}

input:focus {
  border: 0;
  outline: 0;
}

.controls {
  position: fixed;
  bottom: 16px;
  left: 16px;
  z-index: 2;
  background: white;
  border-radius: 5px;
  color: rgba(0, 0, 0, 0.5);
  padding: 1rem;
  font-size: 14px;
  font-family: sans-serif;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1), 0px 0px 1px rgba(0, 0, 0, 0.1);
}

@media (max-width: 1200px) {
  .controls {
    display: none;
  }
}

button {
  -webkit-appearance: none;
  border: 0;
  outline: 0;
  background: transparent;
  font-size: 14px;
  cursor: pointer;
}

button:hover {
  opacity: 0.8;
}

button:active {
  color: black;
}
</style>
